import styled from 'styled-components';
import { formatDate } from '../../../utils/helpers';
import { useState } from 'react';

interface IGallery {
  base64String: string;
  dateCreated: string;
  onClick: ({ data }: { data: string }) => void;
}

export const GalleryImage = ({
  base64String,
  dateCreated,
  onClick,
}: IGallery) => {
  const [isLoading, setIsLoading] = useState(true);
  const [isError, setIsError] = useState(false);

  return (
    <ImageItem>
      {isLoading && <ImagePlaceholder>Loading...</ImagePlaceholder>}
      {isError && <ImagePlaceholder>Error loading image</ImagePlaceholder>}

      <img
        src={`data:image/png;base64,${base64String}`}
        alt="proctored-image"
        style={{
          width: '120px',
          cursor: 'pointer',
          display: isLoading || isError ? 'none' : 'block',
        }}
        onLoad={() => setIsLoading(false)}
        onError={() => {
          setIsError(true);
          setIsLoading(false);
        }}
        onClick={() => onClick({ data: base64String })}
      />

      <ImageTitle>{formatDate(new Date(dateCreated))}</ImageTitle>
    </ImageItem>
  );
};

const ImagePlaceholder = styled.div`
  width: 120px;
  height: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f0f0f0;
  color: #666;
  font-size: 0.9rem;
  text-align: center;
  border: 1px solid #ddd;
  border-radius: 8px;
`;

const ImageItem = styled.div`
  img {
    padding: 0;
    margin: 0;
  }
`;

const ImageTitle = styled.div`
  font-size: 10px;
  text-align: center;
  padding: 0;
`;
